import { RootState, StoreState } from "@store/store";
import { Query, VBA } from "../../utils/types";

export type ArchiveState = {
  all: Query[];
  vba: VBA[];
  setAllQueries: (queries: Query[]) => void;
  setAllVba: (vba: VBA[]) => void;
  addQuery: (query: Query) => void;
  addVba: (vba: VBA) => void;
  updateQueryFeedback: (id: string, isCorrect: boolean) => void;
  updateVbaFeedback: (id: string, isCorrect: boolean) => void;
};

export const createArchiveSlice: StoreState<ArchiveState> = (set) => ({
  all: [],
  vba: [],

  setAllQueries: (queries) => {
    set(({ archiveDataState }) => {
      archiveDataState.all = queries;
    });
  },
  setAllVba: (vba) => {
    set(({ archiveDataState }) => {
      archiveDataState.vba = vba;
    });
  },

  addQuery: (query) => {
    set(({ archiveDataState }) => {
      archiveDataState.all = [query, ...archiveDataState.all];
    });
  },

  addVba: (vba) => {
    set(({ archiveDataState }) => {
      archiveDataState.vba = [vba, ...archiveDataState.vba];
    });
  },

  updateQueryFeedback: (id, isCorrect) => {
    set(({ archiveDataState }) => {
      const index = archiveDataState.all.findIndex((q) => q.id === id);
      if (index !== -1) {
        archiveDataState.all[index].isCorrect = isCorrect;
      }
    });
  },

  updateVbaFeedback: (id, isCorrect) => {
    set(({ archiveDataState }) => {
      const index = archiveDataState.vba.findIndex((v) => v.id === id);
      if (index !== -1) {
        archiveDataState.vba[index].isCorrect = isCorrect;
      }
    });
  },
});

export const selectArchiveDataActions = (state: RootState) => ({
  setAllQueries: state.archiveDataState.setAllQueries,
  setAllVba: state.archiveDataState.setAllVba,
  addQuery: state.archiveDataState.addQuery,
  updateQueryFeedback: state.archiveDataState.updateQueryFeedback,
  addVba: state.archiveDataState.addVba,
  updateVbaFeedback: state.archiveDataState.updateVbaFeedback,
});

export const selectAllQueries = (state: RootState) =>
  state.archiveDataState.all;
